import { render, staticRenderFns } from "./AppTextBox.vue?vue&type=template&id=8a0289c2"
import script from "./AppTextBox.vue?vue&type=script&lang=ts"
export * from "./AppTextBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports